/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiOnboardingType;
(function (ApiOnboardingType) {
    ApiOnboardingType["ONBOARDING_TYPE_UNKNOWN"] = "OnboardingTypeUnknown";
    ApiOnboardingType["ONBOARDING_TYPE_WOO_COMMERCE"] = "OnboardingTypeWooCommerce";
    ApiOnboardingType["ONBOARDING_TYPE_SHOPIFY"] = "OnboardingTypeShopify";
})(ApiOnboardingType || (ApiOnboardingType = {}));
export function ApiOnboardingTypeFromJSON(json) {
    return ApiOnboardingTypeFromJSONTyped(json, false);
}
export function ApiOnboardingTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiOnboardingTypeToJSON(value) {
    return value;
}
